export default __webpack_public_path__ + "static/media/field.2e61133b.png";